import { defineStore, storeToRefs } from 'pinia'
import { ref } from 'vue'

import { API } from '@/client/utils/api'
import { CampaignAccount, GetCampaignAccountsResponse } from '@/typings/campaign_accounts'

import { useSystemStore } from './useSystemStore'

export const useCampaignAccountStore = defineStore('campaignAccountStore', () => {
  const systemStore = useSystemStore()
  const { currentGroupId } = storeToRefs(systemStore)

  const api_accounts = ref<CampaignAccount[]>([])

  const fetchCampaignAccounts = async (): Promise<GetCampaignAccountsResponse> => {
    const groupId = currentGroupId.value

    if (typeof groupId !== 'number') {
      return {}
    }

    const response: GetCampaignAccountsResponse = await API.get('v1/campaign_accounts', {
      params: { group_id: groupId }
    })

    if (response.data) {
      api_accounts.value = response.data
    }

    return response
  }

  return { api_accounts, fetchCampaignAccounts }
})
